import { calculate } from '@calculations/price/strategies/fixed-discount/calculate';
import {
  Tab as ChakraTab,
  Table,
  TableContainer,
  TabPanel,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { QueryNoResults } from '@ui/components/query';
import { styles } from '@ui/components/TanstackTable/styles';
import { actions } from '@ui/features/quote-builder/state/reducer';
import { selectQuoteBuilder } from '@ui/features/quote-builder/state/selectors/quote-builder';
import { selectQuoteLineWithLeadTimeIssues } from '@ui/features/quote-builder/state/selectors/quote-line';
import { QuoteInfoTab } from '@ui/features/quote-builder/types/state/quote-line';
import { useDispatch } from '@ui/hooks/useDispatch';
import { useSelector } from '@ui/hooks/useSelector';
import { currency } from '@ui/util';

import { useQuoteLineContext } from '../QuoteLineProvider';
import { TabComponentType } from './types';

const tab = QuoteInfoTab.DiscountPriceBook;

function Tab() {
  const dispatch = useDispatch();
  const { quoteLineUuid } = useQuoteLineContext();

  function handleTabChange() {
    dispatch(actions.quoteLineInfoTabChanged({ quoteLineUuid, tab }));
  }

  return <ChakraTab onClick={handleTabChange}>Price Book</ChakraTab>;
}

function DiscountPriceBookPanel() {
  const { quoteLineUuid } = useQuoteLineContext();
  const calculationConfig = useSelector(
    (state) => selectQuoteBuilder(state).calculationConfig,
  );
  const { discountPrices, quotePrices, quotePriceUuids } = useSelector(
    (state) => selectQuoteLineWithLeadTimeIssues(state, quoteLineUuid),
  );

  if (!discountPrices) {
    return <QueryNoResults title="No fixed pricing found" />;
  }

  return (
    <TableContainer width="100%">
      <Table width="100%" sx={styles} size="sm">
        <Thead>
          <Tr>
            <Th rowSpan={2}>Discount</Th>

            <Th colSpan={10}>Quantity Breaks</Th>
          </Tr>
          <Tr>
            {quotePriceUuids.map((quotePriceUuid) => (
              <Th key={quotePriceUuid}>
                {quotePrices[quotePriceUuid].quantity.toString()}
              </Th>
            ))}
          </Tr>
        </Thead>

        <Tbody>
          {discountPrices.map((row) => {
            return (
              <Tr key={row.discount_code}>
                <Td>{row.discount_code}</Td>
                {quotePriceUuids.map((quotePriceUuid) => {
                  const quotePrice = quotePrices[quotePriceUuid];
                  const result = calculate(
                    {
                      quantity: quotePrice.quantity,
                      discountCode: row.discount_code,
                      discountPrices,
                    },
                    calculationConfig,
                  );

                  if (!result) {
                    return <Td key={quotePriceUuid}>-</Td>;
                  }

                  return (
                    <Td key={quotePriceUuid}>{currency(result.unitPrice)}</Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </TableContainer>
  );
}

function Panel() {
  return (
    <TabPanel>
      <DiscountPriceBookPanel />
    </TabPanel>
  );
}

export const DiscountPriceBook = {
  tab,
  Tab,
  Panel,
} satisfies TabComponentType;
